import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";

const Splash = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!loading) {
      const redirectTimer = setTimeout(() => {
        if (user) {
          navigate(user.onboarding_completed ? '/dashboard' : '/onboarding');
        } else {
          navigate('/welcome');
        }
      }, 2500);
      return () => clearTimeout(redirectTimer);
    }
  }, [user, loading, navigate]);

  return (
    <div 
      className="min-h-screen bg-[#0A0A0A] flex flex-col items-center justify-center relative overflow-hidden"
      data-testid="splash-screen"
    >
      {/* Full screen logo background */}
      <div 
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-[0.08] pointer-events-none"
        style={{ backgroundImage: `url(${LOGO_URL})` }}
      />

      {/* Ambient glow */}
      <div className="absolute inset-0 bg-gradient-radial from-[#D4AF37]/10 via-transparent to-transparent" />
      
      {/* Gold accent lines */}
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" />

      {/* Hexagon pattern overlay */}
      <div className="absolute inset-0 hexagon-bg opacity-50" />

      <div className={`relative z-10 text-center transition-all duration-1000 ${showContent ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        {/* Main Logo */}
        <div className="mb-8 relative">
          <img 
            src={LOGO_URL} 
            alt="Track365 Cardio" 
            className="w-72 sm:w-80 h-auto relative z-10"
            data-testid="splash-logo"
          />
        </div>

        {/* Heartbeat line animation */}
        <div className="w-64 h-8 mx-auto mb-6 overflow-hidden">
          <svg viewBox="0 0 200 40" className="w-full h-full">
            <path
              d="M0 20 L40 20 L50 10 L60 30 L70 15 L80 25 L90 20 L200 20"
              fill="none"
              stroke="#D4AF37"
              strokeWidth="2"
              className="animate-pulse"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* Tagline */}
        <p className="text-zinc-400 text-sm tracking-[0.3em] uppercase font-medium">
          TRACK IT. BUILD IT. BECOME IT.
        </p>

        {/* Loading indicator */}
        <div className="mt-10">
          <div className="w-10 h-10 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto" />
        </div>
      </div>
    </div>
  );
};

export default Splash;
